var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "li",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vLi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64,4A60,60,0,1,1,4,64,60,60,0,0,1,64,4ZM84.11,92.2H97.6c0-.41.07-.71.07-1,0-7.5,0-15,0-22.5a29.88,29.88,0,0,0-.63-6c-1.32-6-4.65-10.41-11-11.79s-11.87,0-15.81,5.59c-.06.1-.17.16-.46.4V51.53H56.31V92.21H69.8V90.59c0-7.33,0-14.66,0-22a7.46,7.46,0,0,1,6.87-7.43c4-.24,6.5,2,7.19,6.35a5.62,5.62,0,0,1,.09.92q.08,10.92.13,21.84C84.12,90.9,84.11,91.5,84.11,92.2Zm-35.52,0V51.53H35.19V92.22Zm-6.7-46.41c3.76,0,6.64-2,7.46-5.15a7,7,0,0,0-4.71-8.56c-4.24-1.29-8.6.57-9.91,4.22C33,41.21,36.48,45.82,41.89,45.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4034d8fc17af5724c903d75f027ad8bb.svg";
export { ForwardRef as ReactComponent };